import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import PromoMessage from '../../promo-message';
import { MediaQuery as MQ } from '../../../media-query';
import { slugify } from '../../../util';
import _ from 'underscore';
import { accScroll } from '../../../page-accordion';
import { hasTouchEvents } from '../../../util';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.subnavs = {
            'summary': [
                {
                    text: 'Overview',
                    slug: 'summary-overview',
                },
                {
                    text: 'Your Birth Charts',
                    slug: 'summary-your-birth-charts',
                },
                {
                    text: `${this.renderName(props.report.product.inputs.person_1_name.first)} Astrology`,
                    slug: 'summary-person-1',
                },
                {
                    text: `${this.renderName(props.report.product.inputs.person_2_name.first)} Astrology`,
                    slug: 'summary-person-2',
                },
            ],
            'your-report': [
            ],
            'glossary': [
            ],
        };

        _.last(props.report.product.display.sections).block.map(block => {
            const slug = block.content.title.match(/Houses/) ? 'houses-meaning' : slugify(block.content.title);
            const title = block.content.title.match(/Houses/) ? 'Houses & Meaning' : block.content.title;
            this.subnavs.glossary.push({
                text: title,
                slug: `glossary-${slug}`,
            });
        });

        if (props.report) {
            props.report.product.navigator.map(section => {
                if (section.prefix && section.prefix != '0:' && section.code != 'glossary') {
                    this.subnavs['your-report'].push({
                        text: `${section.prefix.replace(/:/, '.')} ${section.long_name}`,
                        slug: `your-report-${section.code.replace(/_/g, '-')}`,
                    });
                }
            });
        }

        this.state = { mainNavOpen: null };
    }

    componentDidMount() {
        window.addEventListener('click', this.handleGlobalClick);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.handleGlobalClick);
    }

    /* eslint-disable max-len */
    render({ mainnavs, route }) {
        return (
            <ascom-navigation
                className='is-hidden-print'
                ref={el => this.el = el}
            >
                <ascom-main-nav className={hasTouchEvents && this.state.mainNavOpen ? 'is-touch-open' : ''}>
                    {mainnavs.map(link => {
                        let className = route.match(link.slug) ? 'active' : '';

                        if (!route && link.slug == 'summary') {
                            className = 'active';
                        }

                        if (hasTouchEvents) {
                            return (
                                <ascom-main-nav-item className={this.state.mainNavOpen == link.slug ? 'is-touch-open' : ''}>
                                    <a
                                        href={`#${link.slug}`}
                                        className={className}
                                        onClick={this.toggleMainNav}
                                    >
                                        {link.text}
                                    </a>
                                    {this.renderSubNav(link.slug)}
                                </ascom-main-nav-item>
                            );
                        }

                        return (
                            <ascom-main-nav-item className='report-nav-hoverable'>
                                <a
                                    href={`#${link.slug}`}
                                    className={className}
                                >
                                    {link.text}
                                </a>
                                {this.renderSubNav(link.slug)}
                            </ascom-main-nav-item>
                        );
                    })}
                </ascom-main-nav>
            </ascom-navigation>
        );
    }
    /* eslint-enable max-len */

    renderSubNav = (slug) => {
        return (
            <ascom-sub-nav>
                <div>
                    {this.renderPromoMessage(slug)}
                    {this.renderSubNavLinks(slug)}
                </div>
            </ascom-sub-nav>
        );
    }

    renderPromoMessage = (slug) => {
        if (!this.props.is_full && slug == 'your-report') {
            return (
                <ascom-nav-upgrade>
                    <PromoMessage placement='in-product' tags='acr,nav' />
                </ascom-nav-upgrade>
            );
        }

        return null;
    }

    renderSubNavLinks = (slug) => {
        if (this.subnavs && this.subnavs[slug]) {
            return this.subnavs[slug].map(link => {
                let className = '';

                if (slug == 'your-report') {
                    if (this.props.is_sample) {
                        className = 'disabled';
                    } else if (!this.props.is_full) {
                        const section_exists = this.props.report.product.display.sections.some((section, i) => {
                            if (i >= 1 || i >= this.props.report.product.display.sections.length) {
                                const section_slug = `your-report-${section.section_code.replace(/_/, '-')}`;
                                if (section_slug == link.slug) {
                                    return true;
                                }
                            }

                            return false;
                        });

                        className = section_exists ? '' : 'disabled';
                    }
                }

                if (this.props.route.match(link.slug)) {
                    className = `${className} active`;
                }

                return (
                    <a
                        href={`#${link.slug}`}
                        onClick={this.setOpen}
                        className={className}
                    >
                        {link.text}
                    </a>
                );
            });
        }

        return null;
    }

    renderName = (name) => {
        return name.toLowerCase().endsWith('s') ? `${name}'` : `${name}'s`;
    }

    toggleMainNav = (e) => {
        if (MQ.isMobile() || MQ.isTablet() || hasTouchEvents) {
            const href = e.target.href.replace(/.*#/, '');

            if (href == this.state.mainNavOpen) {
                this.setState({ mainNavOpen: null });
            } else {
                this.setState({ mainNavOpen: href });
            }
        }

        this.setOpen(e, true);
    }

    setOpen = (e, main = false) => {
        e.preventDefault();

        if (!e.target.classList.contains('disabled')) {
            this.props.routeTo(e.target.href.replace(/.*#/, ''));

            if ((MQ.isMobile() || MQ.isTablet() || hasTouchEvents) && e.target.parentNode.tagName == 'DIV') {
                this.setState({ mainNavOpen: null });
            }
        }

        if (!main && e.target && e.target.hash) {
            accScroll(e.target.hash.replace('#', ''), 300);
        }
    }

    handleGlobalClick = (e) => {
        if ((MQ.isMobile() || MQ.isTablet() || hasTouchEvents) && e.target != this.el && !this.el.contains(e.target)) {
            this.setState({ mainNavOpen: null });
        }
    }
}

const mapStateToProps = (state) => ({
    report: state.report,
    route: state.route,
    code: state.report && state.report.product_code,
    is_sample: state.report && state.report.product_code
        && state.report.product_code == 'astrology-compatibility-sample',
    is_full: state.report && state.report.product_code
        && state.report.product_code == 'astrology-compatibility-redux',
    has_birth_time: state.report && state.report.product && state.report.product.restrictions
        && state.report.product.restrictions[0] && state.report.product.restrictions[0] == 'has_birth_time',
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (payload) => dispatch({ type: 'route:to', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);